import { Disposer } from "common/disposer";
import { Button as CommonButton } from "common/pixi/button";
import { cancel, delayAnimation } from "common/promises";
import { Sheets } from "common/sheets";
export class Button extends CommonButton {
    constructor({ pixiContext, sheets, disposable, }) {
        // TODO: 클릭 핸들러를 설정한 뒤 disposable에 세팅하자.
        const textures = Sheets.animationTextures(sheets, "button");
        const hitArea = { x: 252, y: 990, w: 236, h: 109 };
        super({
            pixiContext,
            textures: textures,
            hitArea,
            hideButtonWhenclick: false,
        });
        const autoKey = {
            value: false,
        };
        const autoKeyLoop = cancel.root(async (canceler) => {
            while (true) {
                canceler.check();
                await delayAnimation(300);
                if (autoKey.value) {
                    this.onDown();
                }
            }
        });
        const onSpace = (event) => {
            if (event.key === " ") {
                this.onDown();
            }
            else if (event.key === "a") {
                autoKey.value = true;
            }
        };
        document.addEventListener("keyup", onSpace);
        disposable.add(new Disposer(() => {
            document.removeEventListener("keyup", onSpace);
            autoKey.value = false;
            autoKeyLoop.canceler.cancel();
        }));
    }
}
//# sourceMappingURL=button.js.map